'use strict';

var hasSymbols = require('has-symbols/shams');

module.exports = function hasToStringTagShams() {
	return hasSymbols() && !!Symbol.toStringTag;
};



/*****************
 ** WEBPACK FOOTER
 ** ./~/has-tostringtag/shams.js
 ** module id = 620
 ** module chunks = 73
 **/